import { Label, TextField, View } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { InvoiceArrivalDetailsFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface InvoiceFreightFormInputProps {}

export const InvoiceFreightFormInput = ({}: InvoiceFreightFormInputProps) => {
  const { t } = useTranslation("invoice_arrival");
  const { control } = useFormContext<InvoiceArrivalDetailsFormValues>();

  return (
    <View>
      <Label label={t("form.invoice_freight.label")}></Label>
      <Controller
        name="freightCost"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <TextField
              value={value ?? "0"}
              onChangeText={onChange}
              validationMessage={error ? error.message : undefined}
              keyboardType="numeric"
              formatterType={error?.message ? undefined : "money"}
            />
          );
        }}
      />
    </View>
  );
};
